// import React, { useEffect, useMemo, useState } from "react";
// import { db } from "../firebase"; // keep this path relative to this file
// import {
//   doc,
//   onSnapshot,
//   collection,
//   query,
//   where,
//   orderBy,
//   onSnapshot as onColSnapshot,
//   updateDoc,
//   serverTimestamp,
//   Timestamp,
//   runTransaction,
//   arrayUnion,
//   arrayRemove,
// } from "firebase/firestore";
// import { toast } from "react-hot-toast";

// /* ---------- helpers ---------- */
// function symbolOf(code) {
//   switch (code) {
//     case "USD":
//       return "$";
//     case "EUR":
//       return "€";
//     case "GBP":
//       return "£";
//     case "INR":
//       return "₹";
//     case "LKR":
//       return "Rs";
//     default:
//       return code || "$";
//   }
// }
// const PAYMENT_WINDOW_MINUTES = 20;

// // Try multiple possible slip fields for compatibility
// function pickReceiptUrl(t) {
//   const x = t || {}; // handle null/undefined
//   return (
//     x.paymentProofUrl ||
//     x.receiptUrl ||
//     x.paymentSlip ||
//     x.paymentSlipUrl ||
//     x.slipUrl ||
//     x.slip ||
//     x.proofUrl ||
//     ""
//   );
// }

// /* ---------- modal shell ---------- */
// function Modal({ open, onClose, children, title, footer }) {
//   if (!open) return null;
//   return (
//     <div className="fixed inset-0 z-[120]">
//       <div className="absolute inset-0 bg-black/60" onClick={onClose} />
//       <div className="absolute inset-0 overflow-auto flex items-start justify-center">
//         <div className="w-full max-w-7xl bg-[#0f1623] text-white rounded-2xl shadow-2xl mt-8 mb-12 border border-white/10">
//           <div className="px-4 py-3 border-b border-white/10 flex items-center gap-3">
//             <h3 className="text-base font-semibold">{title}</h3>
//             <button
//               onClick={onClose}
//               className="ml-auto px-2 py-1 rounded bg-white/10 hover:bg-white/15"
//             >
//               ✕
//             </button>
//           </div>
//           <div className="p-4">{children}</div>
//           {footer ? (
//             <div className="px-4 py-3 border-t border-white/10">{footer}</div>
//           ) : null}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ---------- receipt preview ---------- */
// function ReceiptPreview({ url }) {
//   if (!url)
//     return (
//       <div className="text-white/60 text-sm">No receipt uploaded yet.</div>
//     );
//   const isPDF = /\.pdf($|\?)/i.test(url);
//   return isPDF ? (
//     <object
//       data={url}
//       type="application/pdf"
//       className="w-full h-[420px] rounded-xl border border-white/10"
//     >
//       <div className="p-2 text-sm text-white/70">
//         Can’t render PDF here.{" "}
//         <a
//           className="text-blue-400 underline"
//           href={url}
//           target="_blank"
//           rel="noreferrer"
//         >
//           Open in new tab
//         </a>
//       </div>
//     </object>
//   ) : (
//     <img
//       src={url}
//       alt="Receipt"
//       className="w-full max-h-[420px] object-contain rounded-xl border border-white/10 bg-black/20"
//     />
//   );
// }

// /* ---------- thumbnail cell for payments table ---------- */
// function ReceiptThumb({ url }) {
//   if (!url) return <span className="text-xs text-white/50">—</span>;
//   const isPDF = /\.pdf($|\?)/i.test(url);
//   return isPDF ? (
//     <a
//       href={url}
//       target="_blank"
//       rel="noreferrer"
//       className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded bg-white/10 hover:bg-white/15"
//     >
//       <span className="inline-block w-4 h-4 rounded bg-white/20 text-[10px] leading-4 text-center">
//         PDF
//       </span>
//       Open
//     </a>
//   ) : (
//     <a href={url} target="_blank" rel="noreferrer" className="block">
//       <img
//         src={url}
//         alt="Slip"
//         className="h-10 w-10 object-cover rounded border border-white/10"
//       />
//     </a>
//   );
// }

// /* ---------- review dialog ---------- */
// function ReviewDialog({
//   open,
//   onClose,
//   ticket,
//   currency,
//   onApprove,
//   onDecline,
//   loading,
// }) {
//   //   const nums = Array.isArray(ticket?.numbers) ? ticket.numbers : [];
//   //   const amount = Number(
//   //     ticket?.amount || (ticket?.unitPrice || 0) * nums.length
//   //   );
//   //   const receiptUrl = pickReceiptUrl(ticket);
//   //   const isPayment = ticket?.status === "payment_submitted";
//   const isPayment = ticket?.status === "payment_submitted";

//   return (
//     <Modal
//       open={open}
//       onClose={onClose}
//       title={isPayment ? "Review Payment" : "Review Request"}
//       footer={
//         <div className="text-xs text-white/50">
//           {isPayment
//             ? "Approve will confirm numbers and mark the payment approved."
//             : "Approve will send payment details and start the payment window."}
//         </div>
//       }
//     >
//       {!ticket ? (
//         <div className="text-white/70">No item selected.</div>
//       ) : (
//         (() => {
//           // compute only when ticket exists
//           const nums = Array.isArray(ticket.numbers) ? ticket.numbers : [];
//           const amount = Number(
//             ticket.amount || (ticket.unitPrice || 0) * nums.length
//           );
//           const isPayment = ticket.status === "payment_submitted";
//           const receiptUrl = pickReceiptUrl(ticket); // null-safe helper

//           return (
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//               {/* left: facts */}
//               <div className="space-y-3">
//                 <div className="bg-white/5 rounded-xl p-3 border border-white/10">
//                   <div className="text-sm text-white/60">User</div>
//                   <div className="font-medium">
//                     {ticket.userName || ticket.userUid || "—"}
//                   </div>
//                   {ticket.userEmail ? (
//                     <div className="text-sm text-white/70">
//                       {ticket.userEmail}
//                     </div>
//                   ) : null}
//                   <div className="text-xs text-white/50">
//                     Ticket ID: {ticket.id}
//                   </div>
//                 </div>

//                 <div className="bg-white/5 rounded-xl p-3 border border-white/10">
//                   <div className="grid grid-cols-2 gap-3 text-sm">
//                     <div>
//                       <div className="text-white/60">Amount</div>
//                       <div className="font-semibold">
//                         {currency}
//                         {amount.toFixed(2)}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="text-white/60">Method</div>
//                       <div className="font-semibold">
//                         {ticket.method || "—"}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="text-white/60">Reference</div>
//                       <div className="font-semibold break-all">
//                         {ticket.reference || "—"}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="text-white/60">Created</div>
//                       <div className="font-semibold">
//                         {ticket.createdAt
//                           ? new Date(ticket.createdAt).toLocaleString()
//                           : "—"}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="mt-2 text-sm text-white/60">
//                     Numbers:{" "}
//                     <span className="font-mono text-white/80">
//                       {nums.length ? nums.join(", ") : "—"}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="flex gap-2">
//                   <button
//                     onClick={() => onApprove?.(ticket)}
//                     disabled={loading}
//                     className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60"
//                   >
//                     {loading
//                       ? "Working…"
//                       : isPayment
//                       ? "Approve Payment"
//                       : "Approve & Send Details"}
//                   </button>
//                   <button
//                     onClick={() => onDecline?.(ticket)}
//                     disabled={loading}
//                     className="px-4 py-2 rounded-lg bg-rose-600 hover:bg-rose-500 disabled:opacity-60"
//                   >
//                     {loading ? "Working…" : "Decline"}
//                   </button>
//                   <button
//                     onClick={onClose}
//                     className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/15"
//                   >
//                     Close
//                   </button>
//                 </div>
//               </div>

//               {/* right: receipt — only for payments */}
//               <div>
//                 <div className="mb-2 text-sm text-white/70">Receipt</div>
//                 {isPayment ? (
//                   <ReceiptPreview url={receiptUrl} />
//                 ) : (
//                   <div className="text-xs text-yellow-300/80">
//                     Not applicable — this is a request waiting for your payment
//                     details.
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         })()
//       )}
//     </Modal>
//   );
// }

// /* ---------- MAIN: AgentQueuesModal ---------- */
// export default function AgentQueuesModal({ open, onClose, user, cardId }) {
//   const [card, setCard] = useState(null);
//   const [loadingCard, setLoadingCard] = useState(true);

//   const [rows, setRows] = useState([]);
//   const [loadingRows, setLoadingRows] = useState(true);

//   // NEW: explicit tab — separate views
//   const [tab, setTab] = useState("requests"); // "requests" | "payments"

//   const [selected, setSelected] = useState(null);
//   const [busy, setBusy] = useState(false);

//   /* ---- Card subscription (optional if cardId given) ---- */
//   useEffect(() => {
//     if (!open) return;
//     if (!cardId) {
//       setCard(null);
//       setLoadingCard(false);
//       return;
//     }
//     setLoadingCard(true);
//     const ref = doc(db, "cards", cardId);
//     const un = onSnapshot(
//       ref,
//       (s) => {
//         setCard(s.exists() ? { id: s.id, ...s.data() } : null);
//         setLoadingCard(false);
//       },
//       (e) => {
//         console.error(e);
//         setLoadingCard(false);
//         toast.error(`Card stream error: ${e.message}`);
//       }
//     );
//     return () => un();
//   }, [open, cardId]);

//   /* ---- Queues subscription (per agent; optional card filter) ---- */
//   useEffect(() => {
//     if (!open || !user?.uid) return;
//     setLoadingRows(true);

//     const base = [
//       where("agentUid", "==", user.uid),
//       ...(cardId ? [where("cardId", "==", cardId)] : []),
//     ];

//     const qRequested = query(
//       collection(db, "tickets"),
//       ...base,
//       where("status", "==", "requested"),
//       orderBy("requestedAt", "asc")
//     );
//     const qSubmitted = query(
//       collection(db, "tickets"),
//       ...base,
//       where("status", "==", "payment_submitted"),
//       orderBy("paymentSubmittedAt", "asc")
//     );

//     let got = false;

//     const un1 = onColSnapshot(qRequested, (snap) => {
//       const arr = [];
//       snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
//       setRows((old) => {
//         const others = old.filter((r) => r.status !== "requested");
//         return [...arr, ...others].sort(sorter);
//       });
//       got = true;
//       setLoadingRows(false);
//     });

//     const un2 = onColSnapshot(qSubmitted, (snap) => {
//       const arr = [];
//       snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
//       setRows((old) => {
//         const others = old.filter((r) => r.status !== "payment_submitted");
//         return [...others, ...arr].sort(sorter);
//       });
//       got = true;
//       setLoadingRows(false);
//     });

//     const t = setTimeout(() => {
//       if (!got) setLoadingRows(false);
//     }, 1500);

//     return () => {
//       clearTimeout(t);
//       un1();
//       un2();
//     };
//   }, [open, user?.uid, cardId]);

//   const currency = symbolOf(card?.currency || "USD");
//   const unit = Number(card?.pricePerNumber || 0);

//   const requests = useMemo(
//     () => rows.filter((r) => r.status === "requested"),
//     [rows]
//   );
//   const payments = useMemo(
//     () => rows.filter((r) => r.status === "payment_submitted"),
//     [rows]
//   );

//   /* -------- actions (same logic you already had) -------- */
//   async function approveRequest(t) {
//     try {
//       setBusy(true);
//       const expiresAt = Timestamp.fromDate(
//         new Date(Date.now() + PAYMENT_WINDOW_MINUTES * 60 * 1000)
//       );
//       await updateDoc(doc(db, "tickets", t.id), {
//         status: "agent_approved",
//         agentApprovedAt: serverTimestamp(),
//         paymentExpireAt: expiresAt,
//         paymentWindowMins: PAYMENT_WINDOW_MINUTES,
//         updatedAt: serverTimestamp(),
//       });
//       toast.success("Request approved");
//     } catch (e) {
//       console.error(e);
//       toast.error(e.message || "Approve failed");
//     } finally {
//       setBusy(false);
//     }
//   }
//   async function declineRequest(t) {
//     try {
//       setBusy(true);
//       await updateDoc(doc(db, "tickets", t.id), {
//         status: "payment_declined",
//         paymentDeclinedAt: serverTimestamp(),
//         updatedAt: serverTimestamp(),
//       });
//       toast.success("Request declined");
//     } catch (e) {
//       console.error(e);
//       toast.error(e.message || "Decline failed");
//     } finally {
//       setBusy(false);
//     }
//   }
//   async function approvePayment(t) {
//     try {
//       setBusy(true);
//       await runTransaction(db, async (tx) => {
//         const cardRef = doc(db, "cards", t.cardId);
//         const ticketRef = doc(db, "tickets", t.id);

//         const cardSnap = await tx.get(cardRef);
//         if (!cardSnap.exists()) throw new Error("Card not found.");
//         const card = cardSnap.data();

//         const unitP = Number(t.unitPrice ?? card.pricePerNumber ?? 0);
//         const picked = Array.isArray(t.numbers) ? t.numbers : [];

//         const filledSet = new Set(card.filled || []);
//         const approvedNums = picked.filter((n) => !filledSet.has(n));
//         if (!approvedNums.length) {
//           tx.update(ticketRef, {
//             status: "payment_approved",
//             paymentApprovedAt: serverTimestamp(),
//             allocated: true,
//             updatedAt: serverTimestamp(),
//           });
//           return;
//         }

//         const amount = Number((approvedNums.length * unitP).toFixed(2));

//         tx.update(cardRef, {
//           filled: arrayUnion(...approvedNums),
//           locked: arrayRemove(...approvedNums),
//           todaySales: Number((card.todaySales || 0) + amount),
//         });

//         tx.update(ticketRef, {
//           status: "payment_approved",
//           paymentApprovedAt: serverTimestamp(),
//           ...(t.allocated ? { allocated: true } : {}),
//           amount,
//           updatedAt: serverTimestamp(),
//         });
//       });
//       toast.success("Payment approved & numbers confirmed");
//     } catch (e) {
//       console.error(e);
//       toast.error(e.message || "Approve failed");
//     } finally {
//       setBusy(false);
//     }
//   }
//   async function declinePayment(t) {
//     try {
//       setBusy(true);
//       await updateDoc(doc(db, "tickets", t.id), {
//         status: "payment_declined",
//         paymentDeclinedAt: serverTimestamp(),
//         updatedAt: serverTimestamp(),
//       });
//       toast.success("Payment declined");
//     } catch (e) {
//       console.error(e);
//       toast.error(e.message || "Decline failed");
//     } finally {
//       setBusy(false);
//     }
//   }

//   // Handlers passed to ReviewDialog
//   const onApprove = (t) =>
//     t.status === "requested" ? approveRequest(t) : approvePayment(t);
//   const onDecline = (t) =>
//     t.status === "requested" ? declineRequest(t) : declinePayment(t);

//   // Table renderers
//   const TableShell = ({ children }) => (
//     <div className="overflow-auto max-h-[65vh]">
//       <table className="w-full text-sm">{children}</table>
//     </div>
//   );

//   const RequestsTable = () => (
//     <TableShell>
//       <thead className="sticky top-0 bg-[#0f1623]">
//         <tr className="[&>th]:py-2 [&>th]:px-3 text-left text-white/70">
//           <th>Created</th>
//           <th>User</th>
//           <th>Amount</th>
//           <th>Numbers</th>
//           <th className="text-right">Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {requests.map((t) => {
//           const nums = Array.isArray(t.numbers) ? t.numbers : [];
//           const amount = Number(
//             t.amount || (t.unitPrice || unit) * nums.length
//           );
//           return (
//             <tr
//               key={t.id}
//               className="border-t border-white/10 hover:bg-white/[0.03]"
//             >
//               <td className="py-2 px-3">
//                 {t.createdAt ? new Date(t.createdAt).toLocaleString() : "—"}
//               </td>
//               <td className="py-2 px-3">
//                 <div className="font-medium">
//                   {t.userName || t.userUid || "—"}
//                 </div>
//                 {t.userEmail ? (
//                   <div className="text-xs text-white/60">{t.userEmail}</div>
//                 ) : null}
//               </td>
//               <td className="py-2 px-3 font-semibold">
//                 {currency}
//                 {amount.toFixed(2)}
//               </td>
//               <td className="py-2 px-3 font-mono">{nums.join(", ") || "—"}</td>
//               <td className="py-2 px-3 text-right whitespace-nowrap">
//                 <button
//                   onClick={() => setSelected(t)}
//                   className="px-3 py-1.5 rounded-md bg-white/10 hover:bg-white/15 mr-2"
//                 >
//                   Review
//                 </button>
//                 <button
//                   onClick={() => approveRequest(t)}
//                   disabled={busy}
//                   className="px-3 py-1.5 rounded-md bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60 mr-2"
//                 >
//                   Approve & Send
//                 </button>
//                 <button
//                   onClick={() => declineRequest(t)}
//                   disabled={busy}
//                   className="px-3 py-1.5 rounded-md bg-rose-600 hover:bg-rose-500 disabled:opacity-60"
//                 >
//                   Decline
//                 </button>
//               </td>
//             </tr>
//           );
//         })}
//       </tbody>
//     </TableShell>
//   );

//   const PaymentsTable = () => (
//     <TableShell>
//       <thead className="sticky top-0 bg-[#0f1623]">
//         <tr className="[&>th]:py-2 [&>th]:px-3 text-left text-white/70">
//           <th>Submitted</th>
//           <th>User</th>
//           <th>Amount</th>
//           <th>Numbers</th>
//           <th>Receipt</th>
//           <th className="text-right">Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {payments.map((t) => {
//           const nums = Array.isArray(t.numbers) ? t.numbers : [];
//           const amount = Number(
//             t.amount || (t.unitPrice || unit) * nums.length
//           );
//           const url = pickReceiptUrl(t);
//           return (
//             <tr
//               key={t.id}
//               className="border-t border-white/10 hover:bg-white/[0.03]"
//             >
//               <td className="py-2 px-3">
//                 {t.paymentSubmittedAt
//                   ? new Date(t.paymentSubmittedAt).toLocaleString()
//                   : t.createdAt
//                   ? new Date(t.createdAt).toLocaleString()
//                   : "—"}
//               </td>
//               <td className="py-2 px-3">
//                 <div className="font-medium">
//                   {t.userName || t.userUid || "—"}
//                 </div>
//                 {t.userEmail ? (
//                   <div className="text-xs text-white/60">{t.userEmail}</div>
//                 ) : null}
//               </td>
//               <td className="py-2 px-3 font-semibold">
//                 {currency}
//                 {amount.toFixed(2)}
//               </td>
//               <td className="py-2 px-3 font-mono">{nums.join(", ") || "—"}</td>
//               <td className="py-2 px-3">
//                 {/* <ReceiptThumb url={url} /> */}
//                 <ReceiptThumb url={selected ? pickReceiptUrl(selected) : ""} />
//               </td>
//               <td className="py-2 px-3 text-right whitespace-nowrap">
//                 <button
//                   onClick={() => setSelected(t)}
//                   className="px-3 py-1.5 rounded-md bg-white/10 hover:bg-white/15 mr-2"
//                 >
//                   Review
//                 </button>
//                 <button
//                   onClick={() => approvePayment(t)}
//                   disabled={busy}
//                   className="px-3 py-1.5 rounded-md bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60 mr-2"
//                 >
//                   Approve Payment
//                 </button>
//                 <button
//                   onClick={() => declinePayment(t)}
//                   disabled={busy}
//                   className="px-3 py-1.5 rounded-md bg-rose-600 hover:bg-rose-500 disabled:opacity-60"
//                 >
//                   Decline
//                 </button>
//               </td>
//             </tr>
//           );
//         })}
//       </tbody>
//     </TableShell>
//   );

//   return (
//     <>
//       <Modal
//         open={open}
//         onClose={onClose}
//         title={
//           <div className="flex items-center gap-3 w-full">
//             <div className="font-semibold">Queues</div>
//             <div className="text-xs text-white/60">
//               {cardId ? (
//                 <>
//                   Card #{card?.id?.slice(0, 8) || "—"} · Unit: {currency}
//                   {unit.toFixed(2)}
//                 </>
//               ) : (
//                 <>All Cards</>
//               )}
//             </div>
//             <div className="ml-auto inline-flex rounded-lg bg-white/5 border border-white/10 p-0.5">
//               <button
//                 onClick={() => setTab("requests")}
//                 className={`px-3 py-1.5 rounded-md text-sm ${
//                   tab === "requests" ? "bg-white/15" : "hover:bg-white/10"
//                 }`}
//               >
//                 Requests ({requests.length})
//               </button>
//               <button
//                 onClick={() => setTab("payments")}
//                 className={`px-3 py-1.5 rounded-md text-sm ${
//                   tab === "payments" ? "bg-white/15" : "hover:bg-white/10"
//                 }`}
//               >
//                 Payments ({payments.length})
//               </button>
//             </div>
//           </div>
//         }
//       >
//         {cardId && loadingCard ? (
//           <div className="p-6 text-white/70">Loading card…</div>
//         ) : null}

//         {loadingRows ? (
//           <div className="p-6 text-white/70">Loading queues…</div>
//         ) : tab === "requests" ? (
//           requests.length ? (
//             <RequestsTable />
//           ) : (
//             <div className="p-6 text-white/70">No requests.</div>
//           )
//         ) : payments.length ? (
//           <PaymentsTable />
//         ) : (
//           <div className="p-6 text-white/70">No payments submitted.</div>
//         )}
//       </Modal>

//       <ReviewDialog
//         open={!!selected}
//         onClose={() => setSelected(null)}
//         ticket={selected}
//         currency={currency}
//         onApprove={(t) => {
//           onApprove(t);
//           setSelected(null);
//         }}
//         onDecline={(t) => {
//           onDecline(t);
//           setSelected(null);
//         }}
//         loading={busy}
//       />
//     </>
//   );
// }

// /* sorter: requested before submitted; newest within each group */
// function sorter(a, b) {
//   const sa = a.status === "requested" ? 0 : 1;
//   const sb = b.status === "requested" ? 0 : 1;
//   if (sa !== sb) return sa - sb;
//   const ta = a.paymentSubmittedAt || a.requestedAt || a.createdAt || 0;
//   const tb = b.paymentSubmittedAt || b.requestedAt || b.createdAt || 0;
//   return (tb || 0) - (ta || 0);
// }

import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase";
import {
  doc,
  onSnapshot,
  collection,
  query,
  where,
  orderBy,
  onSnapshot as onColSnapshot,
  updateDoc,
  serverTimestamp,
  Timestamp,
  runTransaction,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { toast } from "react-hot-toast";

/* ---------- helpers ---------- */
function symbolOf(code) {
  switch (code) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "INR":
      return "₹";
    case "LKR":
      return "Rs";
    default:
      return code || "$";
  }
}
const PAYMENT_WINDOW_MINUTES = 20;
const SKEW_MS = 2000; // 2s skew tolerance

// Try multiple possible slip fields for compatibility
function pickReceiptUrl(t) {
  const x = t || {};
  return (
    x.paymentProofUrl ||
    x.receiptUrl ||
    x.paymentSlip ||
    x.paymentSlipUrl ||
    x.slipUrl ||
    x.slip ||
    x.proofUrl ||
    ""
  );
}

// best available Date for a ticket
function bestDate(t) {
  return (
    t.paymentSubmittedAt?.toDate?.() ||
    t.requestedAt?.toDate?.() ||
    t.createdAt?.toDate?.() ||
    null
  );
}

/* ---------- modal shell ---------- */
function Modal({ open, onClose, children, title, footer }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[120]">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="absolute inset-0 overflow-auto flex items-start justify-center">
        <div className="w-full max-w-7xl bg-[#0f1623] text-white rounded-2xl shadow-2xl mt-8 mb-12 border border-white/10">
          <div className="px-4 py-3 border-b border-white/10 flex items-center gap-3">
            <h3 className="text-base font-semibold">{title}</h3>
            <button
              onClick={onClose}
              className="ml-auto px-2 py-1 rounded bg-white/10 hover:bg-white/15"
            >
              ✕
            </button>
          </div>
          <div className="p-4">{children}</div>
          {footer ? (
            <div className="px-4 py-3 border-t border-white/10">{footer}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

/* ---------- receipt preview ---------- */
function ReceiptPreview({ url }) {
  if (!url)
    return (
      <div className="text-white/60 text-sm">No receipt uploaded yet.</div>
    );
  const isPDF = /\.pdf($|\?)/i.test(url);
  return isPDF ? (
    <object
      data={url}
      type="application/pdf"
      className="w-full h-[420px] rounded-xl border border-white/10"
    >
      <div className="p-2 text-sm text-white/70">
        Can’t render PDF here.{" "}
        <a
          className="text-blue-400 underline"
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          Open in new tab
        </a>
      </div>
    </object>
  ) : (
    <img
      src={url}
      alt="Receipt"
      className="w-full max-h-[420px] object-contain rounded-xl border border-white/10 bg-black/20"
    />
  );
}

/* ---------- thumbnail cell for payments table ---------- */
function ReceiptThumb({ url, extraCount = 0 }) {
  if (!url) return <span className="text-xs text-white/50">—</span>;
  const isPDF = /\.pdf($|\?)/i.test(url);
  return (
    <div className="flex items-center gap-2">
      {isPDF ? (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded bg-white/10 hover:bg-white/15"
        >
          <span className="inline-block w-4 h-4 rounded bg-white/20 text-[10px] leading-4 text-center">
            PDF
          </span>
          Open
        </a>
      ) : (
        <a href={url} target="_blank" rel="noreferrer" className="block">
          <img
            src={url}
            alt="Slip"
            className="h-10 w-10 object-cover rounded border border-white/10"
          />
        </a>
      )}
      {extraCount > 0 && (
        <span className="text-xs px-2 py-1 rounded bg-white/10">
          +{extraCount}
        </span>
      )}
    </div>
  );
}

/* ---------- review dialog ---------- */
function ReviewDialog({
  open,
  onClose,
  ticket,
  currency,
  onApprove,
  onDecline,
  loading,
}) {
  const isPayment = ticket?.status === "payment_submitted";
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={isPayment ? "Review Payment" : "Review Request"}
      footer={
        <div className="text-xs text-white/50">
          {isPayment
            ? "Approve will confirm numbers and mark the payment approved."
            : "Approve will send payment details and start the payment window."}
        </div>
      }
    >
      {!ticket ? (
        <div className="text-white/70">No item selected.</div>
      ) : (
        (() => {
          const nums = Array.isArray(ticket.numbers) ? ticket.numbers : [];
          const amount = Number(
            ticket.amount || (ticket.unitPrice || 0) * nums.length
          );
          const receiptUrl = pickReceiptUrl(ticket);
          return (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {/* left: facts */}
              <div className="space-y-3">
                <div className="bg-white/5 rounded-xl p-3 border border-white/10">
                  <div className="text-sm text-white/60">User</div>
                  <div className="font-medium">
                    {ticket.userName || ticket.userUid || "—"}
                  </div>
                  {ticket.userEmail ? (
                    <div className="text-sm text-white/70">
                      {ticket.userEmail}
                    </div>
                  ) : null}
                  <div className="text-xs text-white/50">
                    Ticket ID: {ticket.id}
                  </div>
                </div>

                <div className="bg-white/5 rounded-xl p-3 border border-white/10">
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <div className="text-white/60">Amount</div>
                      <div className="font-semibold">
                        {currency}
                        {amount.toFixed(2)}
                      </div>
                    </div>
                    <div>
                      <div className="text-white/60">Method</div>
                      <div className="font-semibold">
                        {ticket.method || "—"}
                      </div>
                    </div>
                    <div>
                      <div className="text-white/60">Reference</div>
                      <div className="font-semibold break-all">
                        {ticket.reference || ticket.referenceId || "—"}
                      </div>
                    </div>
                    <div>
                      <div className="text-white/60">Created</div>
                      <div className="font-semibold">
                        {bestDate(ticket)?.toLocaleString?.() || "—"}
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 text-sm text-white/60">
                    Numbers:{" "}
                    <span className="font-mono text-white/80">
                      {nums.length ? nums.join(", ") : "—"}
                    </span>
                  </div>
                </div>

                <div className="flex gap-2">
                  <button
                    onClick={() => onApprove?.(ticket)}
                    disabled={loading}
                    className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60"
                  >
                    {loading
                      ? "Working…"
                      : isPayment
                      ? "Approve Payment"
                      : "Approve & Send Details"}
                  </button>
                  <button
                    onClick={() => onDecline?.(ticket)}
                    disabled={loading}
                    className="px-4 py-2 rounded-lg bg-rose-600 hover:bg-rose-500 disabled:opacity-60"
                  >
                    {loading ? "Working…" : "Decline"}
                  </button>
                  <button
                    onClick={onClose}
                    className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/15"
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* right: receipt — only for payments */}
              <div>
                <div className="mb-2 text-sm text-white/70">Receipt</div>
                {isPayment ? (
                  <ReceiptPreview url={receiptUrl} />
                ) : (
                  <div className="text-xs text-yellow-300/80">
                    Not applicable — this is a request waiting for your payment
                    details.
                  </div>
                )}
              </div>
            </div>
          );
        })()
      )}
    </Modal>
  );
}

/* ---------- grouping helpers ---------- */
function deriveBundleKey(t) {
  if (t.bundleId) return t.bundleId;
  const userKey = t.userUid || t.userMobileE164 || t.userMobile || "unknown";
  const agentKey = t.agentUid || "agent";
  return `${agentKey}|${userKey}`;
}
function displayUser(t) {
  return (
    t.userName ||
    t.username ||
    t.email ||
    (t.userMobileE164 ? `Mobile ${String(t.userMobileE164).slice(-4)}` : "") ||
    (t.userUid ? t.userUid.slice(0, 6) : "Buyer")
  );
}
function groupTickets(tickets) {
  const map = new Map();
  for (const t of tickets) {
    const key = deriveBundleKey(t);
    const g = map.get(key) || {
      key,
      userLabel: displayUser(t),
      tickets: [],
      currency: t.currency || "USD",
      totalAmount: 0,
      totalNumbers: 0,
      cards: new Set(),
      earliestAt: null,
      proofUrls: [],
    };
    const nums = Array.isArray(t.numbers) ? t.numbers.length : 0;
    const unit = Number(t.unitPrice || 0);
    const amt = Number(t.amount || unit * nums);
    g.tickets.push(t);
    g.totalAmount += amt;
    g.totalNumbers += nums;
    if (t.cardId) g.cards.add(String(t.cardId).slice(0, 8));
    const at = bestDate(t);
    if (at && (!g.earliestAt || at < g.earliestAt)) g.earliestAt = at;
    const u = pickReceiptUrl(t);
    if (u) g.proofUrls.push(u);
    map.set(key, g);
  }
  return Array.from(map.values()).sort(
    (a, b) =>
      (b.earliestAt?.getTime?.() || 0) - (a.earliestAt?.getTime?.() || 0)
  );
}

/* ---------- MAIN: AgentQueuesModal ---------- */
export default function AgentQueuesModal({ open, onClose, user, cardId }) {
  const [card, setCard] = useState(null);
  const [loadingCard, setLoadingCard] = useState(true);

  const [rows, setRows] = useState([]);
  const [loadingRows, setLoadingRows] = useState(true);

  const [tab, setTab] = useState("requests"); // "requests" | "payments"
  const [selected, setSelected] = useState(null);
  const [busy, setBusy] = useState(false);

  /* ---- Card subscription (optional if cardId given) ---- */
  useEffect(() => {
    if (!open) return;
    if (!cardId) {
      setCard(null);
      setLoadingCard(false);
      return;
    }
    setLoadingCard(true);
    const ref = doc(db, "cards", cardId);
    const un = onSnapshot(
      ref,
      (s) => {
        setCard(s.exists() ? { id: s.id, ...s.data() } : null);
        setLoadingCard(false);
      },
      (e) => {
        console.error(e);
        setLoadingCard(false);
        toast.error(`Card stream error: ${e.message}`);
      }
    );
    return () => un();
  }, [open, cardId]);

  /* ---- Queues subscription (per agent; optional card filter) ---- */
  useEffect(() => {
    if (!open || !user?.uid) return;
    setLoadingRows(true);

    const base = [
      where("agentUid", "==", user.uid),
      ...(cardId ? [where("cardId", "==", cardId)] : []),
    ];

    const qRequested = query(
      collection(db, "tickets"),
      ...base,
      where("status", "==", "requested"),
      orderBy("requestedAt", "asc")
    );
    const qSubmitted = query(
      collection(db, "tickets"),
      ...base,
      where("status", "==", "payment_submitted"),
      orderBy("paymentSubmittedAt", "asc")
    );

    let got = false;

    const un1 = onColSnapshot(qRequested, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setRows((old) => {
        const others = old.filter((r) => r.status !== "requested");
        return [...arr, ...others].sort(sorter);
      });
      got = true;
      setLoadingRows(false);
    });

    const un2 = onColSnapshot(qSubmitted, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setRows((old) => {
        const others = old.filter((r) => r.status !== "payment_submitted");
        return [...others, ...arr].sort(sorter);
      });
      got = true;
      setLoadingRows(false);
    });

    const t = setTimeout(() => {
      if (!got) setLoadingRows(false);
    }, 1500);

    return () => {
      clearTimeout(t);
      un1();
      un2();
    };
  }, [open, user?.uid, cardId]);

  const currency = symbolOf(card?.currency || "USD");
  const unit = Number(card?.pricePerNumber || 0);

  const requests = useMemo(
    () => rows.filter((r) => r.status === "requested"),
    [rows]
  );
  const payments = useMemo(
    () => rows.filter((r) => r.status === "payment_submitted"),
    [rows]
  );

  // GROUPS (one row per buyer)
  const groupedRequests = useMemo(() => groupTickets(requests), [requests]);
  const groupedPayments = useMemo(() => groupTickets(payments), [payments]);

  /* -------- actions -------- */
  async function approveRequest(t) {
    const expiresAt = Timestamp.fromDate(
      new Date(Date.now() + PAYMENT_WINDOW_MINUTES * 60 * 1000 + SKEW_MS)
    );
    const derivedBundle =
      t.bundleId ||
      `${t.agentUid || "agent"}|${
        t.userUid || t.userMobileE164 || t.userMobile || "unknown"
      }`;
    await updateDoc(doc(db, "tickets", t.id), {
      status: "agent_approved",
      agentApprovedAt: serverTimestamp(),
      paymentExpireAt: expiresAt,
      paymentWindowMins: PAYMENT_WINDOW_MINUTES,
      bundleId: derivedBundle,
      updatedAt: serverTimestamp(),
    });
  }
  async function declineRequest(t) {
    await updateDoc(doc(db, "tickets", t.id), {
      status: "payment_declined",
      paymentDeclinedAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  }
  async function approvePayment(t) {
    await runTransaction(db, async (tx) => {
      const cardRef = doc(db, "cards", t.cardId);
      const ticketRef = doc(db, "tickets", t.id);

      const cardSnap = await tx.get(cardRef);
      if (!cardSnap.exists()) throw new Error("Card not found.");
      const c = cardSnap.data();

      const unitP = Number(t.unitPrice ?? c.pricePerNumber ?? 0);
      const picked = Array.isArray(t.numbers) ? t.numbers : [];

      const filledSet = new Set(c.filled || []);
      const approvedNums = picked.filter((n) => !filledSet.has(n));

      const amount = Number((approvedNums.length * unitP).toFixed(2));
      if (approvedNums.length) {
        tx.update(cardRef, {
          filled: arrayUnion(...approvedNums),
          locked: arrayRemove(...approvedNums),
          todaySales: Number((c.todaySales || 0) + amount),
        });
      }

      tx.update(ticketRef, {
        status: "payment_approved",
        paymentApprovedAt: serverTimestamp(),
        ...(t.allocated ? { allocated: true } : {}),
        amount,
        updatedAt: serverTimestamp(),
      });
    });
  }
  async function declinePayment(t) {
    await updateDoc(doc(db, "tickets", t.id), {
      status: "payment_declined",
      paymentDeclinedAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  }

  // Batch wrappers
  const approveRequestGroup = async (g) => {
    try {
      setBusy(true);
      await Promise.all(g.tickets.map((t) => approveRequest(t)));
      toast.success(`Approved ${g.tickets.length} request(s).`);
    } catch (e) {
      console.error(e);
      toast.error(e.message || "Approve failed");
    } finally {
      setBusy(false);
    }
  };
  const approvePaymentGroup = async (g) => {
    try {
      setBusy(true);
      // sequential to avoid card write contention
      for (const t of g.tickets) await approvePayment(t);
      toast.success(`Approved ${g.tickets.length} payment(s).`);
    } catch (e) {
      console.error(e);
      toast.error(e.message || "Approve failed");
    } finally {
      setBusy(false);
    }
  };
  const declineGroup = async (g, kind) => {
    try {
      setBusy(true);
      if (kind === "request") {
        await Promise.all(g.tickets.map((t) => declineRequest(t)));
      } else {
        await Promise.all(g.tickets.map((t) => declinePayment(t)));
      }
      toast.success(`Declined ${g.tickets.length} item(s).`);
    } catch (e) {
      console.error(e);
      toast.error(e.message || "Decline failed");
    } finally {
      setBusy(false);
    }
  };

  // UI shells
  const TableShell = ({ children }) => (
    <div className="overflow-auto max-h-[65vh]">
      <table className="w-full text-sm">{children}</table>
    </div>
  );

  const RequestsTable = () => (
    <TableShell>
      <thead className="sticky top-0 bg-[#0f1623]">
        <tr className="[&>th]:py-2 [&>th]:px-3 text-left text-white/70">
          <th>Created</th>
          <th>User</th>
          <th>Amount</th>
          <th>Numbers</th>
          <th>Cards</th>
          <th className="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        {groupedRequests.map((g) => (
          <tr
            key={g.key}
            className="border-t border-white/10 hover:bg-white/[0.03]"
          >
            <td className="py-2 px-3">
              {g.earliestAt ? g.earliestAt.toLocaleString() : "—"}
            </td>
            <td className="py-2 px-3 font-medium truncate">{g.userLabel}</td>
            <td className="py-2 px-3 font-semibold">
              {symbolOf(g.currency)}
              {g.totalAmount.toFixed(2)}
            </td>
            <td className="py-2 px-3">{g.totalNumbers}</td>
            <td className="py-2 px-3">
              {[...g.cards].slice(0, 3).join(", ")}
              {g.cards.size > 3 ? ` +${g.cards.size - 3}` : ""}
            </td>
            <td className="py-2 px-3 text-right whitespace-nowrap">
              <button
                onClick={() => setSelected(g.tickets[0])}
                className="px-3 py-1.5 rounded-md bg-white/10 hover:bg-white/15 mr-2"
              >
                Review
              </button>
              <button
                onClick={() => approveRequestGroup(g)}
                disabled={busy}
                className="px-3 py-1.5 rounded-md bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60 mr-2"
              >
                Approve & Send
              </button>
              <button
                onClick={() => declineGroup(g, "request")}
                disabled={busy}
                className="px-3 py-1.5 rounded-md bg-rose-600 hover:bg-rose-500 disabled:opacity-60"
              >
                Decline
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </TableShell>
  );

  const PaymentsTable = () => (
    <TableShell>
      <thead className="sticky top-0 bg-[#0f1623]">
        <tr className="[&>th]:py-2 [&>th]:px-3 text-left text-white/70">
          <th>Submitted</th>
          <th>User</th>
          <th>Amount</th>
          <th>Numbers</th>
          <th>Cards</th>
          <th>Receipt</th>
          <th className="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        {groupedPayments.map((g) => {
          const firstUrl = g.proofUrls[0] || "";
          const extra = Math.max(0, g.proofUrls.length - 1);
          return (
            <tr
              key={g.key}
              className="border-t border-white/10 hover:bg-white/[0.03]"
            >
              <td className="py-2 px-3">
                {g.earliestAt ? g.earliestAt.toLocaleString() : "—"}
              </td>
              <td className="py-2 px-3 font-medium truncate">{g.userLabel}</td>
              <td className="py-2 px-3 font-semibold">
                {symbolOf(g.currency)}
                {g.totalAmount.toFixed(2)}
              </td>
              <td className="py-2 px-3">{g.totalNumbers}</td>
              <td className="py-2 px-3">
                {[...g.cards].slice(0, 3).join(", ")}
                {g.cards.size > 3 ? ` +${g.cards.size - 3}` : ""}
              </td>
              <td className="py-2 px-3">
                <ReceiptThumb url={firstUrl} extraCount={extra} />
              </td>
              <td className="py-2 px-3 text-right whitespace-nowrap">
                <button
                  onClick={() => setSelected(g.tickets[0])}
                  className="px-3 py-1.5 rounded-md bg-white/10 hover:bg-white/15 mr-2"
                >
                  Review
                </button>
                <button
                  onClick={() => approvePaymentGroup(g)}
                  disabled={busy}
                  className="px-3 py-1.5 rounded-md bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60 mr-2"
                >
                  Approve Payment
                </button>
                <button
                  onClick={() => declineGroup(g, "payment")}
                  disabled={busy}
                  className="px-3 py-1.5 rounded-md bg-rose-600 hover:bg-rose-500 disabled:opacity-60"
                >
                  Decline
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </TableShell>
  );

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={
          <div className="flex items-center gap-3 w-full">
            <div className="font-semibold">Queues</div>
            <div className="text-xs text-white/60">
              {cardId ? (
                <>
                  Card #{card?.id?.slice(0, 8) || "—"} · Unit: {currency}
                  {unit.toFixed(2)}
                </>
              ) : (
                <>All Cards</>
              )}
            </div>
            <div className="ml-auto inline-flex rounded-lg bg-white/5 border border-white/10 p-0.5">
              <button
                onClick={() => setTab("requests")}
                className={`px-3 py-1.5 rounded-md text-sm ${
                  tab === "requests" ? "bg-white/15" : "hover:bg-white/10"
                }`}
              >
                Requests ({groupedRequests.length})
              </button>
              <button
                onClick={() => setTab("payments")}
                className={`px-3 py-1.5 rounded-md text-sm ${
                  tab === "payments" ? "bg-white/15" : "hover:bg-white/10"
                }`}
              >
                Payments ({groupedPayments.length})
              </button>
            </div>
          </div>
        }
      >
        {cardId && loadingCard ? (
          <div className="p-6 text-white/70">Loading card…</div>
        ) : null}

        {loadingRows ? (
          <div className="p-6 text-white/70">Loading queues…</div>
        ) : tab === "requests" ? (
          groupedRequests.length ? (
            <RequestsTable />
          ) : (
            <div className="p-6 text-white/70">No requests.</div>
          )
        ) : groupedPayments.length ? (
          <PaymentsTable />
        ) : (
          <div className="p-6 text-white/70">No payments submitted.</div>
        )}
      </Modal>

      <ReviewDialog
        open={!!selected}
        onClose={() => setSelected(null)}
        ticket={selected}
        currency={currency}
        onApprove={async (t) => {
          try {
            setBusy(true);
            if (t.status === "requested") await approveRequest(t);
            else await approvePayment(t);
          } catch (e) {
            console.error(e);
            toast.error(e.message || "Action failed");
          } finally {
            setBusy(false);
            setSelected(null);
          }
        }}
        onDecline={async (t) => {
          try {
            setBusy(true);
            if (t.status === "requested") await declineRequest(t);
            else await declinePayment(t);
          } catch (e) {
            console.error(e);
            toast.error(e.message || "Action failed");
          } finally {
            setBusy(false);
            setSelected(null);
          }
        }}
        loading={busy}
      />
    </>
  );
}

/* sorter: requested before submitted; newest within each group */
function sorter(a, b) {
  const sa = a.status === "requested" ? 0 : 1;
  const sb = b.status === "requested" ? 0 : 1;
  if (sa !== sb) return sa - sb;
  const ta = bestDate(a)?.getTime?.() || 0;
  const tb = bestDate(b)?.getTime?.() || 0;
  return tb - ta;
}
